import React, { useEffect, useState, useContext} from 'react'
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { DataGrid, GridToolbar} from '@mui/x-data-grid'
import Typography from '@mui/material/Typography';
import { Button, CardActionArea, CardActions } from '@mui/material';
import '../../styles/PeoplesRequestsUI.css';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { useSearchParams } from 'react-router-dom';
import { UserContext } from '../UserContext';
import Grid from '@mui/material/Grid';
import { useNavigate } from "react-router-dom";
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import Checkbox from '@mui/material/Checkbox';
import MyConnectionsUI from '../MyConnectionsUI';
import Switch from '@mui/material/Switch';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const PeoplesRequestsUI = (props) => {

//UseState
var navigate = useNavigate();
const { user, setUser} = useContext(UserContext);
const [toggle,setToggle] = useState(false);
const [ allStatus,setAllStatus] = useState("");
const [requests,setRequests]= useState([]);
const [selectedCommunity,setSelectedCommunity] = useState([])
const [communities,setCommunities] = useState([]);


 //UseEffect
 useEffect(()=>{
   
 
   if(user){
   
   
     getRequests()
    
   }
},[user])
  
const ConnectionReq = (id,status)=>{  
  let confirmation=window.confirm("Are you sure ?")
  if(!confirmation){
    return
  }
if(selectedCommunity==="undefined"){
  setSelectedCommunity(JSON.parse([]))
}
    let apiURL=process.env.REACT_APP_API_URL + "/connection/updateconnection/"+id;
    let apiParams = {
        method:"POST",
        headers:{
          status:status,
          user2selectedcommunity:encodeURIComponent(JSON.stringify(selectedCommunity)),
        },
    };
    
    fetch(apiURL, apiParams)
    .then((res)=> (res.status===200 ? res.json() : res.text()))
    .then((repos)=> {
        if (repos.data) {
        alert("Action Updated Successfully!!");
          
      //props.showAlert("Job Added Successfully","success")
         setTimeout(() => {
          // getStatus()
           getRequests()
        }, 1500);
        
        }else alert(repos.message || repos);
    }) 
    .catch((err) => alert(err));
  
}



//Converting Image
function arrayBufferToBase64(buffer) {
  var binary = "";
  var bytes = [].slice.call(new Uint8Array(buffer));
  bytes.forEach((b) => (binary += String.fromCharCode(b)));
  var base64Flag = "data:image/jpeg;base64,";
  return base64Flag + window.btoa(binary);
}


const getRequests = ()=>{
 
  let apiURL = process.env.REACT_APP_API_URL + "/connection/getrequests/" + user._id;
  let apiParams = {
    method: "GET",
  };
  fetch(apiURL, apiParams)
    .then((res) => (res.status === 200 ? res.json() : res.text()))
    .then((repos) => {
      if (repos.data) {
          // console.log(repos.data)
          setRequests(repos.data)
          
      } else alert(repos.message || repos);
    })
    .catch((err) => alert(err));
};


  return (
    <div id="Request_Page">
    <div id="heading_grp_conreqsug_req_page">
      <div id="conreqsug_req_page_new_pc_req">
        <span>Request</span>
      </div>
      <div id="selected_grp_conreqsug_req_pag">
        <div id="conreqsug_req_page_new_pc_conn" onClick={()=>props.selectedTab("Connections")}>
          <span>Connections</span>
        </div>
      </div>
      <div id="conreqsug_req_page_new_pc_sug" onClick={()=>props.selectedTab("Suggestions")}>
        <span>Suggestions</span>
      </div>
      <svg class="underline_conreqsug_req_page_n">
        <rect id="underline_conreqsug_req_page_n" rx="0" ry="0" x="0" y="0" width="64" height="3">
        </rect>
      </svg>
    </div>
    <svg class="desgin_3_conreqsug_req_page_ne">
      <rect id="desgin_3_conreqsug_req_page_ne" rx="0" ry="0" x="0" y="0" width="100%" height="203">
      </rect>
    </svg>
    <div id="Scroll_req_new_layout">
    {(requests||[]).map((rs)=>(
        
		<div id="card_1_req_page_pc_inichan">
			<svg class="over_all_card_erq_page_new_pc" onClick={()=>navigate("../"+(rs.user1Name===user.name ? rs.user2Image.nickName:rs.user1Image.nickName))}>
				<rect id="over_all_card_erq_page_new_pc" rx="10" ry="10" x="0" y="0" width="185" height="320">
				</rect>
			</svg>
			<img id="Anime_Edit_goku_thats_me" src={rs.user1Name===user.name ?  (rs.user2Image.imageUrl && rs.user2Image.imageUrl!=="") ?process.env.REACT_APP_GOOGLEDRIVE_VIEW_IMG+(rs.user2Image.imageUrl.split('/')[5]):"./Peoples/DefaultImageCon.png":(rs.user1Image.imageUrl && rs.user1Image.imageUrl!=="") ?process.env.REACT_APP_GOOGLEDRIVE_VIEW_IMG+(rs.user1Image.imageUrl.split('/')[5]):"./Peoples/DefaultImageCon.png"} onClick={()=>navigate("../"+(rs.user1Name===user.name ? rs.user2Image.nickName:rs.user1Image.nickName))}/>
				
			<div id="designation_grp_req_page_new" onClick={()=>navigate("../"+(rs.user1Name===user.name ? rs.user2Image.nickName:rs.user1Image.nickName))}>
				<img id="job-seeker_img_erq_page_new_pc" src="./Peoples/job-seeker_img_erq_page_new_pc.png" srcset="./Peoples/job-seeker_img_erq_page_new_pc.png 1x" />
					
				<div id="erq_page_new_pc_job_name">
					<span>{rs.user1Name===user.name ?  rs.user2Image ?rs.user2Image.profession:"":rs.user1Image ? rs.user1Image.profession:""}</span>
				</div>
			</div>
			<div id="Mohammed_Affan_goku_v" onClick={()=>navigate("../"+(rs.user1Name===user.name ? rs.user2Image.nickName:rs.user1Image.nickName))}>
				<span>{rs.user1Name===user.name ? rs.user2Name:rs.user1Name}</span>
			</div>


      {user.name==rs.user1Name ?  
			<div title="Cancel" id="reject_erq_page_new_pc" onClick={(e) =>{ConnectionReq(rs._id,"Cancelled")}}>
				<svg class="reqj_erq_page_new_pc">
					<ellipse id="reqj_erq_page_new_pc" rx="19" ry="19" cx="19" cy="19">
					</ellipse>
				</svg>
				<img id="reject_img_erq_page_new_pc" src="./Peoples/reject_img_erq_page_new_pc.png" srcset="./Peoples/reject_img_erq_page_new_pc.png 1x" />
			</div>
:
			<div title="Accept" id="accept_grp_erq_page_new_pc" onClick={(e) =>{ConnectionReq(rs._id,"Connected")}}>
				<svg class="accept_bdr_erq_page_new_pc">
					<ellipse id="accept_bdr_erq_page_new_pc" rx="19" ry="19" cx="19" cy="19">
					</ellipse>
				</svg>
				<img id="accept_img_erq_page_new_pc" src="./Peoples/accept_img_erq_page_new_pc.png" srcset="./Peoples/accept_img_erq_page_new_pc.png 1x" />	
			</div>
      }
      {user.name!=rs.user1Name ?
      <div title="Reject" id="reject_erq_page_new_pc" onClick={(e) =>{ConnectionReq(rs._id,"Rejected")}}>
				<svg class="reqj_erq_page_new_pc">
					<ellipse id="reqj_erq_page_new_pc" rx="19" ry="19" cx="19" cy="19">
					</ellipse>
				</svg>
				<img id="reject_img_erq_page_new_pc" src="./Peoples/reject_img_erq_page_new_pc.png" srcset="./Peoples/reject_img_erq_page_new_pc.png 1x" />	
			</div>:""}
      {user.name!=rs.user1Name ?
			<div title="Ignore" id="ignore_grp_erq_page_new_pc" onClick={(e) =>{ConnectionReq(rs._id,"Ignored")}}>
				<svg class="bg_ignore_erq_page_new_pc">
					<ellipse id="bg_ignore_erq_page_new_pc" rx="19" ry="19" cx="19" cy="19">
					</ellipse>
				</svg>
				<img id="ignore_u_erq_page_new_pc" src="./Peoples/ignore_u_erq_page_new_pc.png" srcset="./Peoples/ignore_u_erq_page_new_pc.png 1x" />		
			</div>:""}
      {user.name!=rs.user1Name ?
			<div title="Block" id="block_grp_erq_page_new_pc" onClick={(e) =>{ConnectionReq(rs._id,"Blocked")}}>
				<svg class="block_bg_erq_page_new_pc">
					<ellipse id="block_bg_erq_page_new_pc" rx="19" ry="19" cx="19" cy="19">
					</ellipse>
				</svg>
				<img id="block_img_erq_page_new_pc" src="./Peoples/block_img_erq_page_new_pc.png" srcset="./Peoples/block_img_erq_page_new_pc.png 1x" />	
			</div>:""}

			<div id="company_name_request_page_new_" onClick={()=>navigate("../"+(rs.user1Name===user.name ? rs.user2Image.nickName:rs.user1Image.nickName))}>
				<img id="office-building_req_page_new_p" src="./Peoples/office-building_req_page_new_p.png" srcset="./Peoples/office-building_req_page_new_p.png 1x" />
					
				<div id="OP_conreqsug_erq_page_new_pc">
					<span>{rs.user1Name===user.name ?  rs.user2Image ?rs.user2Image.businessName:"":rs.user1Image ? rs.user1Image.businessName:""}</span>
				</div>
			</div>
			<marquee id="marquee_op_intro_person">
				<span>{rs.intro}</span>
			</marquee>
		</div>
    ))}
	</div>

  </div>
  )
}

export default PeoplesRequestsUI
